import { FunctionComponent } from "react";

interface PageNotFoundProps {}

const PageNotFound: FunctionComponent<PageNotFoundProps> = () => {
  return <>404 - PAGE NOT FOUND</>;
};

export default PageNotFound;
